import { gql } from '@apollo/client'

export const JURNODES_USERS_QUERY = gql`
  query jurnodesUsers {
    jurnodesUsers {
      collection {
        id
        name
      }
    }
  }
`
